import React, {Component} from "react";
import {toast} from "react-toastify";
import i18n from "../../i18n";
import {CURRENCY_CODES} from "./currencyCodes";

export class CurrencySelect extends Component {
    // La lista vive en `currencyCodes.js`: la comparte con el paso 4 del túnel, que pinta su propio
    // selector. Se deja el estático por los call-sites que ya lo nombran.
    static currenciesCodes = CURRENCY_CODES
    static AD_ACCOUNT_CURRENCY = "Moneda de cuenta publicitaria";

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    getCurrenciesCodes() {
        let currencies = CurrencySelect.currenciesCodes;
        if(this.props.onlyAdAccountCurrencyMode === true) {
            return currencies.concat([CurrencySelect.AD_ACCOUNT_CURRENCY]);
        }
        return currencies
    }

    handleChange(event) {
        if(this.props.onlyAdAccountCurrencyMode === true && event.target.value !== CurrencySelect.AD_ACCOUNT_CURRENCY) {
            event.preventDefault();
            toast.info(i18n.t('currency_select.multi_currency_module_required'));
            return;
        }

        if(this.props.onChange) {
            this.props.onChange(event);
        }
    }

    renderNullOptionIfNecessary() {
        if(this.props.selected === null) {
            return <option key='empty-option' value=''>-----</option>
        }
    }

    render() {
        let selected = this.props.selected;
        if(this.props.onlyAdAccountCurrencyMode === true) {
            selected = CurrencySelect.AD_ACCOUNT_CURRENCY;
        }

        if(this.props.readOnly===true) {
            return <input value={selected} readOnly={true} className={"form-control"}/>
        }

        const options = this.getCurrenciesCodes();
        return (<select className={"form-control form-select"}
                        value={selected} {...this.props}
                        onChange={this.handleChange}
                        required={this.props.required}
            >
                {this.renderNullOptionIfNecessary()}
                {options.map((option) => (
                    <option value={option}
                            key={option}
                    >{option}</option>
                ))}
            </select>
        )
    }
}
